(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('VectorDialogCtrl', vectorDialogCtrl);

    function vectorDialogCtrl(
        $scope,
        $mdDialog,
        $timeout,
        $location,
        LibrariesAPIService,
        MultipleFileUploadService,
        VectorUtilService,
        blockUI,
        initialPosition,
        initialSort,
        library,
        element
    ) {
        $scope.element = element;
        $scope.vectorPosition = initialPosition;
        $scope.vectorSort = initialSort;
        $scope.categoryId = $location.search().categoryId;
        $scope.errorMessage = '';
        $scope.svgPath = '';
        $scope.currentEPS = {};
        $scope.filesToUpload = [];

        // Set position if available. If element is not null we are in edit mode.
        if (element != null) {
            $scope.vectorPosition = element.position;
            $scope.svgPath = element.svgPath;
            $scope.currentEPS = {
                EPS: element.epsPath,
                SVG: element.svgPath,
                ThumbnailPath: element.ThumbnailPath
            };
            $scope.vectorSort = element.Sort;
        }

        $scope.create = async function () {
            if (!$scope.filesToUpload.length && !$scope.svgPath) {
                return;
            }

            var uploadedEPSs = [];
            // Upload pending EPS files
            if ($scope.filesToUpload.length > 0) {
                // Upload each EPS to the server
                blockUI.start('Uploading EPS files 0%');
                uploadedEPSs = await MultipleFileUploadService.uploadVectorsWithChunks(
                    $scope.filesToUpload,
                    4,
                    true,
                    function (progress) {
                        blockUI.message('Uploading EPS files ' + parseInt(progress) + '%');
                        $timeout(() => $scope.$apply());
                    }
                );
                blockUI.stop();
            } else {
                uploadedEPSs.push($scope.currentEPS);
            }

            // If element is not null we are in edit mode, update the element instead of creating it
            if (element === null) {
                // Save every uploaded EPS into the library, increment the position for each one starting from the current
                //  selected position.
                var position = $scope.vectorPosition;
                var sort = $scope.vectorSort;
                var promises = [];

                blockUI.start('Saving vector(s) into library');
                uploadedEPSs.forEach((element, idx) => {
                    (function (element, position, sort) {
                        promises.push(
                            new Promise((resolve, reject) => {
                                LibrariesAPIService.addElement(
                                    library.LibraryId,
                                    position,
                                    {
                                        svgPath: element.SVG,
                                        epsPath: element.EPS,
                                        ThumbnailPath: element.ThumbnailPath,
                                        LibraryCategoryId: $scope.categoryId
                                    },
                                    'vector',
                                    $scope.fileName ? $scope.fileName : $scope.filesToUpload[idx].name.split('.')[0],
                                    sort
                                )
                                    .then(function () {
                                        // New vector added!
                                        resolve();
                                    })
                                    .catch(function (e) {
                                        // If there's an element in this position already, update it
                                        if (e.status === 409) {
                                            console.log('Overwriting position ' + position);
                                            LibrariesAPIService.getLibraryElementAtPosition(library.LibraryId, position)
                                                .then(function (vector) {
                                                    // When only uploading a single EPS, don't allow overwriting existing positions
                                                    if (uploadedEPSs.length === 1) {
                                                        $scope.errorMessage =
                                                            "There's already an element at position " + position;
                                                        reject();
                                                    } else {
                                                        // Update the element that already exists
                                                        vector.svgPath = element.SVG;
                                                        vector.epsPath = element.EPS;
                                                        vector.ThumbnailPath = element.ThumbnailPath;
                                                        vector.LibraryCategoryId = $scope.categoryId;

                                                        LibrariesAPIService.updateElement(
                                                            library.LibraryId,
                                                            vector.VectorID,
                                                            vector,
                                                            'vector'
                                                        )
                                                            .then(function () {
                                                                resolve();
                                                            })
                                                            .catch(function (e) {
                                                                reject(e);
                                                            });
                                                    }
                                                })
                                                .catch(function (e) {
                                                    reject(e);
                                                });
                                        } else {
                                            reject(e);
                                        }
                                    });
                            })
                        );
                    })(element, position++, sort++);
                });

                // Wait for all the elements to be added
                Promise.all(promises)
                    .then(function () {
                        blockUI.stop();
                        $mdDialog.hide();
                    })
                    .catch(function () {
                        blockUI.stop();
                    });
            } else {
                // Update vector
                element.svgPath = $scope.currentEPS.SVG;
                element.epsPath = $scope.currentEPS.EPS;
                element.ThumbnailPath = $scope.currentEPS.ThumbnailPath;
                element.LibraryCategoryId = $scope.categoryId;

                blockUI.start('Updating vector');
                LibrariesAPIService.updateElement(library.LibraryId, element.VectorID, element, 'vector')
                    .then(function () {
                        // Vector updated!
                        blockUI.stop();
                        $mdDialog.hide();
                    })
                    .catch(function (e) {
                        blockUI.stop();
                        $scope.errorMessage = 'Error updating vector!';
                    });
            }
        };

        $scope.uploadEPS = async function (event) {
            const files = event.target.files;
            if (files && files[0]) {
                try {
                    // If we are uploading more than one file don't upload the EPSs now as we can't preview multiple
                    //  EPS files in a small dialog (we also don't want to upload many EPS files for no reason to the
                    //  server) so just save the files and upload them later.
                    // Also we don't support uploading multiple files when in edit mode (element is not null).
                    if (files.length > 1 && !element) {
                        $scope.filesToUpload = files;
                        $scope.svgPath = '';
                        return;
                    }

                    $scope.filesToUpload = [];
                    $scope.errorMessage = '';

                    // Upload the EPS file
                    $scope.uploadingVectorEPS = true;
                    $scope.vectorEPSUploadPercent = 0;
                    blockUI.start('Uploading EPS');

                    const response = await VectorUtilService.uploadVectorToS3(
                        files[0],
                        'vector',
                        false,
                        true,
                        (type, progress) => {
                            if (type === 'upload') {
                                blockUI.message(`Uploading EPS: ${parseInt(progress)}%`);
                                $timeout(() => $scope.$apply());
                            } else {
                                blockUI.message(`Processing`);
                            }
                        }
                    );

                    console.log('Success on EPS upload!');
                    $scope.errorMessage = '';
                    $scope.svgPath = response.SVG;
                    $scope.currentEPS = response;
                    $scope.fileName = files[0].name.split('.')[0]; // nameOfVector.jpg -> nameOfVector

                    blockUI.stop();
                    $scope.uploadingVectorEPS = false;
                    $timeout(() => $scope.$apply());
                } catch (error) {
                    console.error(error);
                    blockUI.stop();
                    $scope.uploadingVectorEPS = false;
                    $scope.errorMessage = error;
                    $timeout(() => $scope.$apply());
                }
            }
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.enter = function () {
            console.log('Enter!');
        };
    }
})();
